import { render, staticRenderFns } from "./index.html?vue&type=template&id=49cab562&lang=html&"
import script from "./prv-multi-select.vue?vue&type=script&lang=js&"
export * from "./prv-multi-select.vue?vue&type=script&lang=js&"
import style0 from "../../stylus/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports